import React from "react";
import { BookedCourtsResponse } from "../../../apis/types";
import { MatchBookingDate } from "./MatchBookingDate";
import { MatchBookingId } from "./MatchBookingId";
import { MatchIndex } from "./MatchIndex";

type props = {
  match: BookedCourtsResponse;
  index: number;
};

export const MatchHeader: React.FC<props> = ({ match, index }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}>
        <MatchIndex index={index} />
        <MatchBookingId bookingId={match.bookingId} />
      </div>
      <MatchBookingDate bookingDate={match.bookingDate} />
    </div>
  );
};
